import { Component,  OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { DirectRfqService } from '../../../services/direct.rfq.service';

@Component({
  selector: 'app-rfq-details-drawer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rfq-details-drawer.component.html',
  styleUrls: ['./rfq-details-drawer.component.scss']
})
export class RfqDetailsDrawerComponent implements OnInit {
  rfqData: any = null;
  urlParams: any = {
    companyId: null,
    contactId: null,
    integration: null,
    isTrackingEnabled: false,
    rfqId: null
  };
  loading: boolean = false;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private directRfqService: DirectRfqService
  ) {}

  ngOnInit() {
    // Get URL parameters
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    this.urlParams = {
      companyId: urlParams.get('companyId'),
      contactId: urlParams.get('contactId'),
      integration: urlParams.get('integration'),
      isTrackingEnabled: urlParams.get('isTrackingEnabled') === 'true',
      rfqId: urlParams.get('rfqId')
    };

    // Fetch RFQ data if we have all required parameters
    if (this.urlParams.companyId && this.urlParams.contactId && this.urlParams.rfqId) {
      this.loading = true;
      this.directRfqService.sideDrawerRfqData(this.urlParams).subscribe({
        next: (response) => {
          this.rfqData = response.data;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        }
      });
    }
  }

  closeDrawer() {
    if (window.parent) {
      window.parent.postMessage({
        closePrivateRfqSideDrawer: true        
      }, '*');
    }
  }

  getFinishDisplay(finish: any): string {
    if (Array.isArray(finish)) {
      return finish.length > 0 ? finish.join(', ') : '-';
    }
    return finish ? finish : '-';
  }
} 